import { connect } from 'react-redux';
import { fetchAllDrafts, fetchAllTeams } from '../../actions/actions-index';
import Drafts from '../../components/Draft/Drafts';

const mapStateToProps = state => {
    return {
        drafts: state.draft,
        draftsLoading: state.draftsLoading,
        teams: state.team,
        user: state.user,
    }
};

export default connect(
    mapStateToProps,
    { fetchAllDrafts, fetchAllTeams }
)(Drafts);



// WEBPACK FOOTER //
// ./src/containers/Draft/DraftViewContainer.js